import React from "react";
import Button from "react-bootstrap/Button";
import Rectangle from '../images/Rectangle.png';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PersonaliseBG from '../images/personaliseBG.png';
import IQOSWHITE from '../images/IQOS-white.png';
import IQOSBLACK from '../images/IQOS-black.png';
import IQOSCOPPER from '../images/IQOS-copper.png';
import IQOSVideoBG from '../images/IQOS-VideoBG.png';
import Footer from "./reusable-components/footer";
import NavBar from '../components/reusable-components/nav-bar';
import WhatsInTheBox from '../components/reusable-components/WhatsInTheBox';
import HowToUse from '../components/reusable-components/HowToUse';
import ShopIQOS from "../components/reusable-components/ShopIQOS";
import FindAStore from '../components/reusable-components/FindAStore';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import MyDeviceInfo from "./reusable-components/myDevice-Info";
import { Link } from 'react-router-dom';
import MyIQOSTab from "./reusable-components/myIQOSTab";


function GetStarted() {

    return (
        <div>
            <div>
                <NavBar />
            </div>

            <div >
                <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
            </div>
            <div style={{
                height: '175px',
                marginBottom: '20px'
            }}>
                <img src={IQOSVideoBG} style={{ width: '100%', height: '175px' }} alt="" />
            </div>
            <div>
                <div style={{
                    fontFamily: 'Sintony',
                    textAlign: 'center',

                    marginLeft: '20px',
                    marginRight: '20px'

                }}>
                    <span style={{
                        color: '#3786C3',
                        fontSize: '14px',
                        fontWeight: '700',
                        // marginBottom: '20px'
                    }}
                    >GETTING STARTED</span>
                    <p style={{
                        fontSize: '13px',
                        marginTop: '20px'
                    }}>
                        Check out this short video introduction to IQOS and our eight-step program!
                    </p>
                </div>
            </div>
            <div>
                <Row>
                    <Col>
                        <WhatsInTheBox />
                    </Col>
                    <Col>
                        <Link to="/how-to-use-page">
                            <HowToUse />
                        </Link>
                    </Col>
                </Row>
                <Row>
                    <Col >
                        <ShopIQOS />
                    </Col>
                    <Col >
                        <FindAStore />
                    </Col>
                </Row>
            </div>

            <div style={{
                font: 'Sintony',
                fontSize: '14px',
                lineHeight: '18.24px',
                color: '#475666',
                textAlign: 'center',
                fontWeight: '700',
                marginBottom: '40px',
                marginTop: '40px'
            }}>
                <span>DASHBOARD</span>


                <MyIQOSTab />

            </div>




            {/* Meet IQOS div */}
            <div style={{
                marginBottom: '30px'
            }}>
                <div style={{
                    font: 'Sintony',
                    fontSize: '14px',
                    lineHeight: '18.24px',
                    color: '#475666',
                    textAlign: 'center',
                    fontWeight: '700',
                    marginBottom: '40px'
                }}>

                    <span>MEET IQOS</span>
                </div>
                <Row>
                    <Col style={{
                        textAlign: 'center'
                    }}>
                        <img src={IQOSWHITE} style={{ width: '76px', height: '136px' }} alt="" />
                    </Col>

                    <Col style={{
                        textAlign: 'center'
                    }}>
                        <img src={IQOSBLACK} style={{ width: '76px', height: '136px' }} alt="" />
                    </Col>

                    <Col style={{
                        textAlign: 'center'
                    }}>
                        <img src={IQOSCOPPER} style={{ width: '76px', height: '136px' }} alt="" />
                    </Col>
                </Row>
                <Row style={{
                    marginTop: '10px',
                    marginBottom: '20px'
                }}>
                    <Col style={{
                        fontSize: '11px',
                        lineHeight: '15px',
                        textAlign: 'center'
                    }}>
                        IQOS 3 DUO KIT
                        WHITE
                    </Col>

                    <Col style={{
                        fontSize: '11px',
                        lineHeight: '15px',
                        textAlign: 'center'
                    }}>
                        IQOS 3 DUO KIT <br></br>
                        BLACK
                    </Col>

                    <Col style={{
                        fontSize: '11px',
                        lineHeight: '15px',
                        textAlign: 'center'
                    }}>
                        IQOS 3 DUO KIT
                        COPPER
                    </Col>
                </Row>

            </div>
            <div style={{
                height: '250px',
                backgroundImage: `url(${PersonaliseBG})`,
                backgroundRepeat: 'no-repeat'
            }}>
                <div style={{

                    textAlign: 'left',

                    color: '#FFFFFF',
                    paddingTop: '85px',
                    paddingLeft: '20px'
                }}>
                    <div style={{
                        fontSize: '17px',
                        fontWeight: '700',
                        font: 'Sintony'

                    }}>
                        Personalize <br></br>
                        your IQOS
                    </div>
                    <div style={{
                        marginTop: '10px'
                    }}>
                        <Button variant="outline-secondary" size="lg" type="submit" style={{
                            height: '43px',
                            width: '123px',
                            fontSize: '12px',
                            borderRadius: '0',
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF'

                        }} >
                            GET STARTED
                        </Button>
                    </div>
                </div>
            </div>
            <div>
                <Footer />
            </div>
        </div >
    );
}

export default GetStarted;